import React from "react";
import StationGraphs from "../../../../components/Graph/StationGraphs";
import MDBox from "../../../../materialDashboard/components/MDBox";
import useActiveFeature from "./useActiveFeature";
import FeatureSelectionChips from "./FeatureSelectionChips";
import useComparisonMode from "./useComparisonMode";
import ComparisonChip from "./ComparisonChip";
import Stack from "@mui/material/Stack";
import StationsComparisonPanel from "./StationsComparisonPanel";


const StationPanel = ({selectedFeatures, onDeSelectFeature}) => {
    const {activeFeatureId, setActiveFeatureId, activeFeature} = useActiveFeature(selectedFeatures);
    const [comparisonMode, setComparisonMode] = useComparisonMode(selectedFeatures);

    const handleSetActiveFeature = (id) => {
        setComparisonMode(false);
        setActiveFeatureId(id);
    }

    if (!activeFeatureId) {
        return null;
    }

    return (
        <MDBox>
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <FeatureSelectionChips
                        selectedFeatures={selectedFeatures}
                        activeFeatureId={comparisonMode ? null : activeFeatureId}
                        setActiveFeatureId={handleSetActiveFeature}
                        onDeSelectFeature={onDeSelectFeature}
                    />
                    <ComparisonChip
                        disabled={selectedFeatures.length <= 1}
                        comparisonMode={comparisonMode}
                        setComparisonMode={setComparisonMode}
                    />
                </Stack>
            </Stack>

            {comparisonMode ? (
                <StationsComparisonPanel selectedFeatures={selectedFeatures} />
            ) : (
                <StationGraphs stationId={activeFeatureId}
                               station={activeFeature?.properties}/>
            )}
        </MDBox>
    );
}

export default StationPanel;
